
import React, { useEffect, useState } from "react";
import { fetch_finance_ratio } from "../../ApisService/apiService";
import styles from "../../../css/dashboard/fundamental/Profitloss.module.css";

const Ratios = ({ selectedCompany }) => {
  const [PNLdata, setPNLData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    if (!selectedCompany || !selectedCompany.fincode) {
      setPNLData([]);
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const ratiodata = await fetch_finance_ratio(selectedCompany.fincode);
        setPNLData(ratiodata.data || []);
      } catch (err) {
        setError("Failed to fetch data.");
      }
      setLoading(false);
    };

    fetchData();
  }, [selectedCompany]);

  const toggleRowVisibility = (key) => {
    setExpandedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  if (!selectedCompany) {
    return <p className={styles.errorText}>No company selected.</p>;
  }

  const years = PNLdata.map((item) => item.Year_end);

  const financialData = [
    { type: "heading", label: "Operational & Financial Ratios" },
    { type: "data", label: "Operational & Financial Ratios", key: "Operational_FinancialRatios", expandable: true },
    { type: "subdata", label: "   Earnings Per Share (Rs)", key: "Reported_EPS", parentKey: "Operational_FinancialRatios" },
    { type: "subdata", label: "   CEPS(Rs)", key: "CEPS", parentKey: "Operational_FinancialRatios" },
    { type: "subdata", label: "   DPS(Rs)", key: "DPS", parentKey: "Operational_FinancialRatios" },
    { type: "subdata", label: "   Book NAV/Share(Rs)", key: "Book_NAV_Share", parentKey: "Operational_FinancialRatios" },

    { type: "data", label: "Margin Ratios", key: "Margin_Ratios", expandable: true },
    { type: "subdata", label: "     Core EBITDA Margin(%)", key: "Core_EBITDA_Margin", parentKey: "Margin_Ratios" },
    { type: "subdata", label: "   CEPS(   EBIT Margin(%))", key: "EBIT_Margin", parentKey: "Margin_Ratios" },
    { type: "subdata", label: "      PAT Margin (%)(Rs)", key: "PAT_Margin", parentKey: "Margin_Ratios" },
    { type: "subdata", label: "    Cash Profit Margin (%)", key: "Cash_Profit_Margin", parentKey: "Margin_Ratios" },

    { type: "data", label: "Performance Ratios", key: "Performance_Ratios", expandable: true },
    { type: "subdata", label: "      ROA(%)", key: "ROA", parentKey: "Performance_Ratios" },
    { type: "subdata", label: "      ROE(%)", key: "ROE", parentKey: "Performance_Ratios" },
    { type: "subdata", label: "     ROCE(%)", key: "ROCE", parentKey: "Performance_Ratios" },
    { type: "subdata", label: "    Asset Turnover(x)", key: "Asset_Turnover", parentKey: "Performance_Ratios" },


    { type: "data", label: " Efficiency Ratios", key: "Efficiency_Ratios", expandable: true },
    { type: "subdata", label: "         Fixed Capital/Sales(x)", key: "Fixed_Capital_Sales", parentKey: "Efficiency_Ratios" },
    { type: "subdata", label: "    Receivable days    ", key: "Receivable_days", parentKey: "Efficiency_Ratios" },
    { type: "subdata", label: "     Inventory Days", key: "Inventory_Days", parentKey: "Efficiency_Ratios" },
    { type: "subdata", label: "     Payable days", key: "Payable_days", parentKey: "Efficiency_Ratios" },



    { type: "data", label: "Valuation Parameters", key: "Valuation_Parameters", expandable: true },
    { type: "subdata", label: "        PER(x)", key: "PER", parentKey: "Valuation_Parameters" },
    { type: "subdata", label: "      PCE(x)   ", key: "PCE", parentKey: "Valuation_Parameters" },
    { type: "subdata", label: "       Price/Book(x)", key: "Price_Book", parentKey: "Valuation_Parameters" },
    { type: "subdata", label: "    Yield(%)", key: "Yield", parentKey: "Valuation_Parameters" },
    { type: "subdata", label: "           EV/Net Sales(x)", key: "EV_Net_Sales", parentKey: "Valuation_Parameters" },
    { type: "subdata", label: "     EV/Core EBITDA(x)   ", key: "EV_Core_EBITDA", parentKey: "Valuation_Parameters" },
    { type: "subdata", label: "       EV/EBIT(x)", key: "EV_EBIT", parentKey: "Valuation_Parameters" },
    { type: "subdata", label: "      EV/CE(x)", key: "EV_CE", parentKey: "Valuation_Parameters" },
    { type: "subdata", label: "       M Cap / Sales", key: "Mcap_Sales", parentKey: "Valuation_Parameters" },



    { type: "data", label: "Growth Ratio", key: "Growth_Ratio", expandable: true },
    { type: "subdata", label: "        Net Sales Growth(%)", key: "Net_Sales_Growth", parentKey: "Growth_Ratio" },
    { type: "subdata", label: "     Core EBITDA Growth(%)   ", key: "Core_EBITDA_Growth", parentKey: "Growth_Ratio" },
    { type: "subdata", label: "     EBIT Growth(%)", key: "EBIT_Growth", parentKey: "Growth_Ratio" },
    { type: "subdata", label: "     PAT Growth(%)", key: "PAT_Growth", parentKey: "Growth_Ratio" },
    { type: "subdata", label: "          EPS Growth(%)", key: "Reported_EPS_Growth", parentKey: "Growth_Ratio" },
    
    { type: "data", label: "Financial Stability Ratios", key: "Financial_Stability_Ratios", expandable: true },
    { type: "subdata", label: "        Total Debt/Equity(x)", key: "Total_Debt_Equity", parentKey: "Financial_Stability_Ratios" },
    { type: "subdata", label: "     Current Ratio(x) ", key: "Current_Ratio", parentKey: "Financial_Stability_Ratios" },
    { type: "subdata", label: "      Quick Ratio(x)", key: "Quick_Ratio", parentKey: "Financial_Stability_Ratios" },
    { type: "subdata", label: "        Interest Cover(x)", key: "Interest_Cover", parentKey: "Financial_Stability_Ratios" },
    { type: "subdata", label: "      Total Debt/Mcap(x)", key: "Total_Debt_Mcap", parentKey: "Financial_Stability_Ratios" },



  ];


  const formatFincode = (fincode) => {
    const fincodeNumber = parseInt(fincode, 10);
    const year = Math.floor(fincodeNumber / 100);
    const month = fincodeNumber % 100;
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return `${year}-${monthNames[month - 1]}`;
  };
  const getSafeNumber = (val) => {
    if (val === undefined || val === null || val === "") return 0; // Fallback for empty values
    const cleaned = String(val).replace(/,/g, "").trim(); // Remove commas and whitespace
    const num = parseFloat(cleaned); // Try converting to float
    return isNaN(num) ? 0 : num; // If not a number, fallback to 0
  };



  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        Financial Data ({selectedCompany.fincode})
      </h2>

      {loading ? (
        <p className={styles.loadingText}>Loading...</p>
      ) : error ? (
        <p className={styles.errorText}>{error}</p>
      ) : PNLdata.length === 0 ? (
        <p className={styles.noDataText}>No data available.</p>
      ) : (
        <div className={styles.tableContainer}>
          <table className={`table-sm ${styles.table}`}>
            <thead>
              <tr>
                <th className={styles.tableHeader}>Metrics</th>
                {years.map((year, index) => (
                  <th key={index} className={styles.tableHeader}>
                    {formatFincode(year)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {financialData.map((item, index) => {
                if (item.type === "heading") {
                  return (
                    <tr key={index} className={styles.sectionRow}>
                      <td colSpan={years.length + 1} className={styles.sectionHeader}>
                        {item.label}
                      </td>
                    </tr>
                  );
                }

                if (item.type === "data") {
                  return (
                    <React.Fragment key={index}>
                      <tr className={styles.tableRow}>
                        <td className={styles.tableCell}>
                          {item.expandable ? (
                            <button
                              onClick={() => toggleRowVisibility(item.key)}
                              className={styles.toggleButton}
                            >
                              {expandedRows[item.key] ? "-" : "+"} {item.label}
                            </button>
                          ) : (
                            item.label
                          )}
                        </td>
                        {PNLdata.map((data, idx) => (
                          <td key={idx} className={styles.tableCell}>
                            {(item.key === "operating_profit_excl_OI") ? (
                              (() => {
                                const netSales = getSafeNumber(data?.Net_sales);
                                const totalExpenditure = getSafeNumber(data?.Total_expendiure);
                                const result = netSales - totalExpenditure;
                                return result.toFixed(2);
                              })()
                            ) : (
                              data[item.key] ?? "–"
                            )}
                          </td>
                        ))}

                      </tr>

                      {/* Show sub-rows when the expandable row is expanded */}
                      {expandedRows[item.key] &&
                        financialData
                          .filter((subItem) => subItem.type === "subdata" && subItem.parentKey === item.key)
                          .map((subItem, subIndex) => (
                            <tr key={`${index}-${subIndex}`} className={styles.subRow}>
                              <td className={styles.subRowCell}>
                                {subItem.label}
                              </td>
                              {PNLdata.map((data, idx) => (
                                <td key={idx} className={styles.subRowCell}>
                                  {(subItem.key === "") ? (
                                    (() => {
                                      return "–";
                                    })()
                                  ) : (
                                    data[subItem.key] ?? "–"
                                  )}



                                </td>
                              ))}
                            </tr>
                          ))}
                    </React.Fragment>
                  );
                }

                return null;
              })}
            </tbody>

          </table>
        </div>
      )}
    </div>
  );
};

export default Ratios;
